var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16699 12.8333L19.2503 2.75",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2502 2.75L13.2919 19.25C13.2516 19.3378 13.1871 19.4121 13.1058 19.4643C13.0246 19.5164 12.9301 19.5441 12.8335 19.5441C12.737 19.5441 12.6425 19.5164 12.5612 19.4643C12.48 19.4121 12.4154 19.3378 12.3752 19.25L9.16685 12.8333L2.75019 9.625C2.66242 9.58478 2.58805 9.52021 2.53591 9.43896C2.48377 9.35772 2.45605 9.26321 2.45605 9.16667C2.45605 9.07013 2.48377 8.97562 2.53591 8.89437C2.58805 8.81312 2.66242 8.74855 2.75019 8.70833L19.2502 2.75Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.5c6526d2271979628562910f2ed224b0.svg";
export { ForwardRef as ReactComponent };